export interface AiChatSettingsInterface {
  id?: number;
  type: 'ai_chat_settings';
  attributes: {
    modelName: string; // Biltenko Azure AI Chat:
    modelVersion: string; // v1.0.0,
    description: string; // Optional description of this chat settings.,

    characterLimit: number; // 10000;
    monthlyQuestionLimitPremium: number; // 5;
    monthlyQuestionLimitStandard: number; // 5;
    monthlyQuestionLimitFree: number; // 5;

    systemMessage: string; // System message for the chat,

    azureOpenaiEndpoint: string; // endpoint,
    azureOpenaiDeploymentId: string; // deploymentId,
    azureAiSearchEndpoint: string; // azureAiSearchEndpoint,
    azureAiSearchIndex: string; // gpt-4o,
    azureOpenaiKey: string; // azureOpenaiKey,
    azureSearchKey: string; // azureSearchKey,
    azureSearchStrictness: number; // 1;
    azureSearchTopK: number; // 20;
    maxTokens?: number; // 4096;
    maxCompletionTokens?: number; // 4096;
    temperature: number; // 0.2;
    topP: number; // 1.0;
    frequencyPenalty: number; // 0.0;
    presencePenalty: number; // 0.0;
    pastMessages: number; // 20;

    azureCosmosdbAccount: string; // azureCosmosdbAccount,
    azureCosmosdbDatabase: string; // azureCosmosdbDatabase,
    azureCosmosdbConversationsContainer: string; // azureCosmosdbConversationsContainer,
    cosmosdbPrimaryKey: string; // cosmosdbPrimaryKey,
    cosmosdbConnectionString: string; // cosmosdbConnectionString,

    queryType: string; // 'vector_simple_hybrid'; -- simple, semantic, vector, vector_simple_hybrid, vector_semantic_hybrid
    semanticConfiguration: string; // 'azureml-default';
    strictness: number; // 1;
    topNDocuments: number; // 20;
    inScope: boolean; // true;

    contentFields: string; // 'content';
    filepathField: string; // 'filepath';
    titleField: string; // 'title';
    urlField: string; // 'url';
    vectorFields: string; // 'contentVector';
    
    embeddingModelName: string; // 'text-embedding-3-large';

    isPublic: boolean; // true;
    active: boolean; // true;

    createdDate?: string;
    modifiedDate?: string;
    createdBy?: number;
    modifiedBy?: number;
  };
}

export interface AiChatSettingsResponseInterface {
  data: Array<AiChatSettingsInterface>;
}

export interface AiChatSettingsResponseInterfaceSingle {
  data: AiChatSettingsInterface;
}

export const listOfNumberInputs = [
  'azureSearchStrictness',
  'azureSearchTopK',
  'maxTokens',
  'maxCompletionTokens',
  'temperature',
  'topP',
  'frequencyPenalty',
  'presencePenalty',
  'pastMessages',
  'monthlyQuestionLimitPremium',
  'monthlyQuestionLimitStandard',
  'monthlyQuestionLimitFree',
  'characterLimit',
  'strictness',
  'topNDocuments',
];
